export var uglifiedAlphabet = {
    A: ['Ẫ', 'Ẳ', 'Ặ', 'Ḁ'],
    B: ['Ḃ', 'Ḇ', '฿'],
    C: ['Ḉ'],
    D: ['Ď', 'Ḑ'],
    E: ['Ế', 'Ệ', 'Ể'],
    F: ['Ƒ', 'Ḟ'],
    G: ['Ģ', 'Ǧ'],
    H: ['Ȟ', 'Ḫ'],
    I: ['Į', 'Ǐ'],
    J: ['Ĵ', 'Ɉ'],
    K: ['Ķ', 'Ḱ', 'Ǩ', 'Ḳ', 'Ḵ'],
    L: ['Ĺ', 'Ļ', 'Ḹ', 'Ḽ'],
    M: ['Ṁ', 'Ṃ'],
    N: ['Ń', 'Ņ', 'Ň', 'Ñ', 'Ṋ'],
    O: ['Ǭ', 'Ổ'],
    P: ['Ṕ', 'Ṗ'],
    Q: ['Ɋ'],
    R: ['Ŕ', 'Ŗ', 'Ř', 'Ȑ', 'Ṝ'],
    S: ['Ṧ', 'Ș', 'Ṩ'],
    T: ['Ť', 'Ṱ'],
    U: ['Ų', 'Ǚ'],
    V: ['Ṽ', 'Ṿ'],
    W: ['Ŵ', 'Ẉ'],
    X: ['Ẋ', 'Ẍ'],
    Y: ['Ỵ', 'Ỷ'],
    Z: ['Ž', 'Ȥ'],
    a: ['ậ', 'ầ'],
    b: ['ƀ', 'ƃ', 'ɓ', 'ḃ', 'ḅ', 'ḇ'],
    c: ['ḉ'],
    d: ['ɖ', 'ḓ'],
    e: ['ę', 'ể', 'ệ'],
    f: ['ƒ', 'ḟ'],
    g: ['ĝ', 'ğ', 'ǧ', 'ǵ', 'ɠ'],
    h: ['ȟ', 'ḧ', 'ḩ', 'ḫ'],
    i: ['į', 'ỉ', 'ḭ'],
    j: ['ĵ', 'ǰ', 'ʝ'],
    k: ['ķ', 'ƙ', 'ḱ', 'ǩ', 'ḳ', 'ḵ'],
    l: ['ĺ', 'ļ', 'ḷ', 'ḹ', 'ḻ', 'ḽ'],
    m: ['ḿ', 'ṁ', 'ṃ'],
    n: ['กี้'],
    o: ['ǭ', 'ổ'],
    p: ['þ', 'ƥ', 'ṕ'],
    q: ['q̗̋', 'q̤̊'],
    r: ['ŗ', 'ř', 'ṝ'],
    s: ['ș', 'ṥ', 'ṧ', 'ṩ'],
    t: ['ṱ', 'ṫ', 'ẗ'],
    u: ['ų', 'ǚ'],
    v: ['ṽ', 'ṿ'],
    w: ['ŵ', 'ẉ', 'ẘ', 'ῴ'],
    x: ['ẋ', 'ẍ'],
    y: ['ÿ̂'],
    z: ['ȥ', 'z̽̾'],
};
export var vowels = [
    'a',
    'e',
    'i',
    'o',
    'u',
    'y',
    'A',
    'E',
    'I',
    'O',
    'U',
    'Y',
];
